import { createTheme } from '@mui/material/styles';

// Gradient and surface tokens for use in sx and global CSS
export const gradients = {
  primary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  primary90: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
  primaryHover: 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)',
  secondary: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  secondaryHover: 'linear-gradient(135deg, #e07de8 0%, #e04458 100%)',
  primarySubtle: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
  primarySubtleHover: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)',
  primaryVerySubtle: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
};

export const surface = {
  glass: 'rgba(255, 255, 255, 0.95)',
  glassBorder: '1px solid rgba(255, 255, 255, 0.3)',
  glassStrong: 'rgba(255, 255, 255, 0.98)',
  contrastTextMuted: 'rgba(255, 255, 255, 0.9)',
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#667eea',
      light: '#8b9cf0',
      dark: '#5568d3',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f5576c',
      light: '#f093fb',
      dark: '#e04458',
      contrastText: '#ffffff',
    },
    background: {
      default: '#5a67d8',
      paper: surface.glass,
    },
  },
  typography: {
    fontFamily: '"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: { fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.02em' },
    h3: { fontWeight: 700, letterSpacing: '-0.01em' },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    'none',
    '0 2px 4px rgba(0,0,0,0.05)',
    '0 4px 12px rgba(0,0,0,0.08)',
    '0 8px 24px rgba(0,0,0,0.1)',
    '0 8px 32px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
    '0 12px 40px rgba(0,0,0,0.12)',
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          border: surface.glassBorder,
          backdropFilter: 'blur(10px)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          border: surface.glassBorder,
          backdropFilter: 'blur(10px)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
        },
      },
    },
  },
  // Custom keys for use in sx: theme.gradients, theme.surface
  gradients,
  surface,
});

export default theme;
